import { Editorcontrolitem } from "./editorcontrolitem.model";
import { DynamicFormLayoutModel } from "./dynamicformlayout.model";
import { DynamicFormRouteModel } from "./dynamicformroute.model";

export class Editor {
    rguid: string;
    Name: string;
    Controls: Editorcontrolitem[];
    Version: string;
    DynamicFormLayoutModel:DynamicFormLayoutModel;
    Routes:DynamicFormRouteModel[];

    constructor(rguid: string, name: string, controls: Editorcontrolitem[], version: string, dynamicFormLayoutModel:DynamicFormLayoutModel, routes:DynamicFormRouteModel[]) {
        this.rguid = rguid;
        this.Name = name;
        this.Controls = controls;
        this.Version = version;
        this.DynamicFormLayoutModel = dynamicFormLayoutModel;
        this.Routes = routes;
    }

    public static map(data: any): Editor {
        let cs = this.mapItems(data.Controls);
        let dflym = DynamicFormLayoutModel.map(data.DynamicFormLayoutModel);
        let dfrouts = this.mapRouteItems(data.Routes);
        return new Editor(data.Rguid, data.Name, cs, data.Version, dflym, dfrouts);
    }


    private static mapItems(items: any[]): Editorcontrolitem[] {
        var controlsArray: Editorcontrolitem[] = [];
        items.forEach(c => {
            let mc = Editorcontrolitem.mapItem(c);
            controlsArray.push(mc);
        });

        return controlsArray;
    }

    private static mapRouteItems(items: any[]): DynamicFormRouteModel[] {
        var array: DynamicFormRouteModel[] = [];
        items.forEach(c => {
            let mc = DynamicFormRouteModel.map(c);
            array.push(mc);
        });

        return array;
    }

    public consolidateModel(){
        this.Controls.forEach( c=> {
                this.consolidateItem(c);
        });
    }

    public consolidateItem(item:Editorcontrolitem){
        item.SettingsJson = JSON.stringify(item.Settings);
        if(item.Children!=null && item.Children.length>0){
            item.Children.forEach(i=>{ this.consolidateItem(i);})
        }
    }
}
